<section class="section-parametre" [ngBusy]="{
    busy: busyGet,
    message: 'Veuillez patienter ...',
    backdrop: false
  }">
      <div class="">
          <div class="row clearfix">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="card">
                      <div class="body table-responsive">
                          <table class="table table-stripped table-bordered table-hover">
                              <thead>
                                  <tr>
                                      <th colspan="12">
                                          <div class="row mt-1">
  
                                              
  
                                              <div class="col-md-5">
                                                  <input [(ngModel)]="searchKey"
                                                      class="form-control custom-input pull-left"
                                                      placeholder="Rechercher ..."
                                                      (keyup)="currentPage = 0; getItems()" />
                                              </div>
  
                                              <div class="col-md-3">
                                                  <!-- <button type="button" class="btn btn-md custom_btn_primary pull-right"
                                                      (click)="openAddItemModal()">
                                                      <i class="fa fa-plus"></i>&nbsp; Ajouter
                                                  </button> -->
                                              </div>
                                          </div>
                                      </th>
                                  </tr>
                                  <tr class="custom-table-head">
                                      <th>
                                          <a style="cursor: pointer" (click)="currentPage = 0; getItems()"
                                              title="Actualiser">
                                              <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                                      </th>
                                      <!-- <th>Code</th> -->
                                      <!-- <th>Code</th> -->
                                      <th>Codification</th>
                                      <th>Libellé</th>
                                      <th>Barème</th>
                                      <th>Police</th>
                                      <th>Tarification</th>
                                      <th>Type remboursement</th>
                                      <th>Créé le</th>
                                      <!-- <th>Crée par</th> -->
                                      <!-- <th>Modifié le</th>
                  <th>Modifié par</th> -->
                                      <!-- <th class="txt-align-center">Actions</th> -->
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr *ngFor="let item of items; let indice = index">
                                      <td class="txt-align-center">{{ currentPage>1?(((currentPage - 1) *
                                          this.itemsPerPage) + (indice+1)):indice+1 }}</td>
                                      <!-- <td>{{ item?.code}}</td> -->
                                      <!-- <td>{{ item?.code}}</td> -->
                                      <td>{{ item?.codification}}</td>
                                      <td>{{ item?.libelle}}</td>
                                      <td>{{ item?.bareme_libelle}}</td>
                                      <td>{{ item?.police_libelle}}</td>
                                      <td>{{ item?.mode_tarification_libelle}}</td>
                                      <td>{{ item?.type_remboursement_libelle}}</td>
                                      <td>{{ item?.created_at | dateTimeFormat}}</td>
                                      <!-- <td>{{ item?.created_by_login}}</td> -->
                                      <!-- <td>{{ item?.updated_at | dateTimeFormat}}</td>
                  <td>{{ item?.updated_by_login}}</td> -->
                                      <!-- <td>
                                          <div class="custom-td-action">
                                              <a title="Modifier" (click)="openAddItemModal(item)"
                                                  class="custom-btn-update">
                                                  <i class="fa fa-edit"></i></a>
                                              <a title="Supprimer" (click)="confirmDelete(item)"
                                                  class="custom-btn-delete">
                                                  <i class="fa fa-trash"></i></a>
                                          </div>
                                      </td> -->
                                  </tr>
                              </tbody>
  
                              <tfoot>
                                  <tr *ngIf="items && items.length > 0">
                                      <td colspan="12">
                                          <div class="row pagination-part">
                                              <div class="col-md-9" style="text-align: center">
                                                  <pagination [maxSize]="5" [boundaryLinks]="true"
                                                      [itemsPerPage]="itemsPerPage" [totalItems]="totalItems"
                                                      [(ngModel)]="currentPage" class="pagination-sm"
                                                      previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
                                                      lastText="&raquo;" (pageChanged)="pageChanged($event)">
                                                  </pagination>
                                              </div>
  
                                              <div class="col-md-3">
                                                  <div class="paginator-per-page">
                                                      <app-element-by-page-paginator (paginationChange)="
                              changePaginationSize($event)
                            " [defaultItemPerPage]="itemsPerPage">
                                                      </app-element-by-page-paginator>
  
                                                      <span class="span_total_entree pull-right">Total : {{ totalItems
                                                          }}</span>
                                                  </div>
                                              </div>
                                          </div>
                                      </td>
                                  </tr>
  
                                  <tr *ngIf="!items || items.length == 0">
                                      <td colspan="12">
                                          <div class="col-md-12 txt-align-center">
                                              Aucune donnée disponible
                                          </div>
                                      </td>
                                  </tr>
                              </tfoot>
                          </table>
                      </div>
                  </div>
  
  
  
              </div>
          </div>
      </div>
  </section>
  
  
  
  <ng-template #templateCrud>
      <div class="modal-header">
          <h4 class="modal-title pull-left">
              {{
              itemToSave?.id
              ? "Modification "+title
              : "Enregistrement "+title
              }}
          </h4>
          <button mat-icon-button class="pull-right" (click)="modalRef.hide()" aria-label="Close dialog">
              <mat-icon>close</mat-icon>
          </button>
      </div>
      <div class="modal-body" [ngBusy]="{
  busy: busySave,
  message: 'Veuillez patienter ...',
  backdrop: false
  }">
          <form class="m-1">
              <div class="row">
                  
                  
  
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Code:
                          <span class="required_champs">*</span>
                      </label>
                      <input class="form-control custom-input"  [disabled]="itemToSave.id" placeholder="Code" autocomplete="off"
                          [(ngModel)]="itemToSave.code" name="code" autocomplete="off" type="text" />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Codification:
                          <span class="required_champs">*</span>
                      </label>
                      <input class="form-control custom-input"   placeholder="Codification" autocomplete="off"
                          [(ngModel)]="itemToSave.codification" name="codification" autocomplete="off" type="text" />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                    <label>Libellé :
                        <span class="required_champs">*</span>
                    </label>
                    <input class="form-control custom-input" placeholder="Libellé" autocomplete="off"
                        [(ngModel)]="itemToSave.libelle" name="libelle" autocomplete="off" type="text" />
                </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                    <label>Catégorie :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select [(ngModel)]="itemToSave.categorie_police_id" 
                        placeholder="Choisissez " name="categorie_police_id" id="categorie_police_id" [multiple]="false"
                        [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsCategoriePolice" [value]="item.id">{{ item.libelle || item.nom+' '+item.prenom }}
                        </ng-option>
                    </ng-select>
                </div>


                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                    <label>Souscripteur :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select [(ngModel)]="itemToSave.souscripteur_id" 
                        placeholder="Choisissez " name="souscripteur_id" id="souscripteur_id" [multiple]="false"
                        [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsSouscripteur" [value]="item.id">{{ item.libelle || item.nom+' '+item.prenom }}
                        </ng-option>
                    </ng-select>
                </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                    <label>Type remboursement :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select [(ngModel)]="itemToSave.type_remboursement_id" 
                        placeholder="Choisissez " name="type_remboursement_id" id="type_remboursement_id" [multiple]="false"
                        [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsTypeRemboursement" [value]="item.id">{{ item?.libelle }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                    <label>Courtier :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select [(ngModel)]="itemToSave.courtier_id" 
                        placeholder="Choisissez " name="courtier_id" id="courtier_id" [multiple]="false"
                        [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsCourtier" [value]="item.id">{{ item.libelle || item.nom+' '+item.prenom }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                    <label>Commercial :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select [(ngModel)]="itemToSave.commerciale_id" 
                        placeholder="Choisissez " name="commerciale_id" id="commerciale_id" [multiple]="false"
                        [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsCommercial" [value]="item.id">{{ item.nom+' '+item.prenom }}
                        </ng-option>
                    </ng-select>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                    <label>Délai de carence :
                        <span class="required_champs">*</span>
                    </label>
                    <input class="form-control custom-input" placeholder="Libellé" autocomplete="off"
                        [(ngModel)]="itemToSave.libelle" name="libelle" autocomplete="off" type="text" />
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                    <label>Seuil alerte consommation :
                        <span class="required_champs">*</span>
                    </label>
                    <input class="form-control custom-input" placeholder="Libellé" autocomplete="off"
                        [(ngModel)]="itemToSave.libelle" name="libelle" autocomplete="off" type="text" />
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                    <label>Rembourser à :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select [(ngModel)]="itemToSave.commerciale_id" 
                        placeholder="Choisissez " name="commerciale_id" id="commerciale_id" [multiple]="false"
                        [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsCommercial" [value]="item.id">{{ item.nom+' '+item.prenom }}
                        </ng-option>
                    </ng-select>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                    <label>Taux suspension tiers payant :
                        <span class="required_champs">*</span>
                    </label>
                    <input class="form-control custom-input" placeholder="Libellé" autocomplete="off"
                        [(ngModel)]="itemToSave.libelle" name="libelle" autocomplete="off" type="text" />
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                    <label>Tarification :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select [(ngModel)]="itemToSave.commerciale_id" 
                        placeholder="Choisissez " name="commerciale_id" id="commerciale_id" [multiple]="false"
                        [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsCommercial" [value]="item.id">{{ item.nom+' '+item.prenom }}
                        </ng-option>
                    </ng-select>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                    <label>Réseau de soin :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select [(ngModel)]="itemToSave.commerciale_id" 
                        placeholder="Choisissez " name="commerciale_id" id="commerciale_id" [multiple]="false"
                        [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsCommercial" [value]="item.id">{{ item.nom+' '+item.prenom }}
                        </ng-option>
                    </ng-select>
                </div>


              </div>
          </form>
      </div>
  
      <div class="modal-footer modal-footer-custom">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <button type="button" (click)="confirmSaveItem(itemToSave)" class="btn btn-md custom_btn_primary pull-right"
                  [disabled]="!itemToSave.libelle" [class.auth-spinner]="loading" [disabled]="loading">
                  {{ itemToSave?.id ? "Modifier" : "Enregistrer" }}
              </button>
              <button type="button" class="btn btn-md btn-cancel pull-right" (click)="modalRef.hide()">
                  Annuler
              </button>
          </div>
      </div>
  </ng-template>